import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 26,
  p: 4,
};

export default function ModalComponent({ open = false, handleClose, children, width }) {
  return (
    <Modal sx={{ borderRadius: "8px" }} open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={{ ...style, width }}>
        {handleClose && (
          <IconButton onClick={handleClose} sx={{ position: "absolute", top: 8, right: 8 }} aria-label="close">
            <CloseIcon />
          </IconButton>
        )}
        {children}
      </Box>
    </Modal>
  );
}
